import auth from "../../../../../../chunks/auth.js";
import { p as prisma } from "../../../../../../chunks/prisma.js";
import { error, json } from "@sveltejs/kit";
const PUT = async ({ params, request, locals: { user } }) => {
  const id = Number(params.id);
  if (!await auth.isAdmin(user)) return error(401, "Unauthorized");
  try {
    const { isPublished } = await request.json();
    await prisma.product.update({
      where: { id },
      data: { isPublished: !!isPublished }
    });
    return json({ success: true });
  } catch (e) {
    console.log("publishProduct Err:", e);
    return error(500, "Internal server error publishing product");
  }
};
export {
  PUT
};
